import isMobile from 'is-mobile';

export const getDevice = ua => (isMobile({ ua }) ? 'mobile' : 'desktop');
